import * as React from "react"

const SvgComponent = (props) => (
    <svg
        width={46}
        height={46}
        viewBox="0 0 36 36" // 37
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            d="M17 15v7.333l5.958-3.666L17 15ZM30.636 26.443a14.484 14.484 0 0 0 1.87-4.19c2.073-7.735-2.518-15.686-10.253-17.759a14.434 14.434 0 0 0-7.505-.003m12.795 25.345a14.48 14.48 0 0 1-12.796 2.67 14.432 14.432 0 0 1-6.934-4.204m-2.3-3.352a14.445 14.445 0 0 1-1.019-10.203 14.457 14.457 0 0 1 6.966-8.923"
            stroke="#fff"
            strokeWidth={2}
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)

export default SvgComponent
